import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Util } from '@/utils/util';
import { AfterViewInit, Component, HostBinding, OnInit, Renderer2, } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApiService } from '@services/api.service';
import { AppService } from '@services/app.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AuthService } from '@/services/auth/auth.service';
import { Colaborador } from '@/store/catalogos/colaborador';
const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit, AfterViewInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user;
    public menu;
    sesion:Colaborador;
    autoOcultarMenu: boolean;
    logo: string ="assets/img/logo.png";
    photo: string ="assets/img/default-profile.png";

    constructor(
        public appService: AppService, private store: Store<AppState>,
        private apiService: ApiService, private toastr: ToastrService
        , public dialog: MatDialog, private router: Router
        , private util: Util, private renderer: Renderer2
        , private authService: AuthService) {
    }

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
        });
        this.user = this.appService.user;
        //this.loadMenu();
        this.autoOcultarMenu = JSON.parse(localStorage.getItem("autoOcultarMenu"));

         this.sesion = this.util.getSesion();
      //this.menu = MENU_1;
        this.menu = this.authService.getMenuAdapted();

       this.logo = this.authService.getLogo();

       this.photo = this.authService.getPhoto();
    }

    ngAfterViewInit() {
        //this.sesion = this.util.getSesion();
    }

    async loadMenu() {
        this.apiService.menu().subscribe(response => {
            this.menu = response;
            localStorage.setItem("menu", response.toString());
        }, error => {

        });
    }

    ocultarMenu() {
        this.util.ocultarMenu(this.renderer);
    }

    changeOcultarMenu() {
        localStorage.setItem("autoOcultarMenu", this.autoOcultarMenu + "");
        this.util.autoOcultarMenu(this.renderer);
    }

}

export const MENU_1 = [
  {
    name: 'Catálogos',
    iconClasses: 'fas fa-folder', // icono correcto para carpetas
    children: [
      { name: 'Colaborador', iconClasses: 'fas fa-user-friends', path: ['/catalogos/colaboradores'] },
      { name: 'Departamento', iconClasses: 'fas fa-building', path: ['/catalogos/departamentos'] },
      { name: 'Proveedor', iconClasses: 'fas fa-truck', path: ['/catalogos/proveedores'] },
      { name: 'Magnitud', iconClasses: 'fas fa-ruler-combined', path: ['/catalogos/magnitud'] },
      { name: 'Unidades', iconClasses: 'fas fa-balance-scale', path: ['/catalogos/unidad'] },
      { name: 'Marcas', iconClasses: 'fas fa-tag', path: ['/catalogos/marca'] },
      { name: 'Código de Equipos', iconClasses: 'fas fa-barcode', path: ['/catalogos/codigoEquipo'] },
      { name: 'Equipos', iconClasses: 'fas fa-tools', path: ['/catalogos/equipo'] },
      { name: 'Patrones', iconClasses: 'fas fa-cubes', path: ['/catalogos/patron'] }
    ]
  },
  {
    name: 'Administrador',
    iconClasses: 'fas fa-user-cog',
    children: [
      { name: 'Perfil', iconClasses: 'fas fa-user-tag', path: ['/administrador/perfil'] },
      { name: 'Usuario', iconClasses: 'fas fa-users-cog', path: ['/administrador/usuario'] },
      { name: 'Empresa', iconClasses: 'fas fa-building', path: ['/administrador/empresa'] }

    ]
  },
  {
    name: 'Consultas',
    iconClasses: 'fas fa-search',
    children: [
      { name: 'Historial de Equipos', iconClasses: 'fas fa-history', path: ['/consultas/historialEquipos'] },
      { name: 'Estatus de Equipos', iconClasses: 'fas fa-clipboard-check', path: ['/consultas/estatusEquipo'] },
      { name: 'Equipos en Calibración Externa', iconClasses: 'fas fa-external-link-alt', path: ['/consultas/equiposCalibracion'] },
      { name: 'Equipos con Análisis Vencidos', iconClasses: 'fas fa-exclamation-triangle', path: ['/consultas/analisisVencidos'] }
    ]
  },
  {
    name: 'Análisis',
    iconClasses: 'fas fa-chart-line',
    children: [
      { name: 'Calibración Interna', iconClasses: 'fas fa-tools', path: ['/analisis/calibracionInterna'] },
      { name: 'Calibración Externa', iconClasses: 'fas fa-wrench', path: ['/analisis/calibracionExterna'] },
      { name: 'R&R Método Largo', iconClasses: 'fas fa-ruler-horizontal', path: ['/analisis/msaRyrml'] },
      { name: 'R&R Método Corto', iconClasses: 'fas fa-ruler-vertical', path: ['/analisis/msaRyrmc'] },
      { name: 'R&R y Variación Parte por Parte', iconClasses: 'fas fa-columns', path: ['/analisis/msaRrvpp'] },
      { name: 'Linealidad', iconClasses: 'fas fa-wave-square', path: ['/analisis/msaLinealidad'] },
      { name: 'Exactitud (Bias)', iconClasses: 'fas fa-bullseye', path: ['/analisis/msaBias'] },
      { name: 'Atributos Método Corto', iconClasses: 'fas fa-th-list', path: ['/analisis/msaAtributos'] },
      { name: 'Estabilidad', iconClasses: 'fas fa-balance-scale-right', path: ['/analisis/msaEstabilidad'] },
      { name: 'Calibración InterPlanta', iconClasses: 'fas fa-project-diagram', path: ['/analisis/interPlanta'] },
      { name: 'R&R para Gages', iconClasses: 'fas fa-sliders-h', path: ['/analisis/msaryrGages'] }
    ]
  }
];
